import React, { useEffect, useState } from 'react'
import { firestore } from '../firebase'
import CircularProgress from '@material-ui/core/CircularProgress';

const Bridge = (props) => {

    const id = props.match.params.id

    useEffect(() => {
        firestore.collection('transactions').doc(id).onSnapshot(snap => {
            const data = snap.data()
            if (data.paymentStatus === 'process' && data.paymentUrl) {
                window.location.replace(data.paymentUrl)
            }
        })
    },[id])

    return (
        <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="loader">
            <CircularProgress />
        </div>
    )
}

export default Bridge